export default "__VITE_ASSET__CLGwrB0b__"